import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { useHookstate } from "@hookstate/core";
import { useEffect } from "react";
import {
  TAGGINGCAR,
  MAP_GLOBAL_STATES,
  COMMON_COMPONENTS_STATES,
} from "globalStore/globalStore";
import { PopUpContainer } from "assets/css/globle";
import { useTranslation } from "react-i18next";

const CarNotAvailableModal = (props) => {
  // const [openLocal, setOpenLocal] = useState(open)
  const { t } = useTranslation();
  const handleClose = () => {
    props.setOpenPopupNotAvailableCars(false);
  };
  const { tagCar } = useHookstate(TAGGINGCAR);
  const {
    showTaggedCarArray,
    taggedCarsSaverGlobalState,
    taggedCarsDisplayerGlobalState,
  } = useHookstate(MAP_GLOBAL_STATES);
  const { findCars } = useHookstate(COMMON_COMPONENTS_STATES);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "400px",
    width: "100%",
    bgcolor: "#fff",
    boxShadow: 24,
  };

  useEffect(() => {
    if (props.notAvailableCars && props.notAvailableCars.length !== 0) {
      // const notFoundCars = props.notAvailableCars.map((item) => item);
      // const localCarsData = JSON.parse(localStorage.getItem("taggedCarsData"))

      let newShowTaggedCarArrayData = showTaggedCarArray
        .get()
        .filter((val) => !props.notAvailableCars.includes(val));
      let newTaggedCarsSaverGlobalState = taggedCarsSaverGlobalState
        .get()
        .filter((val) => !props.notAvailableCars.includes(val));

      showTaggedCarArray.set(newShowTaggedCarArrayData);
      taggedCarsSaverGlobalState.set(newTaggedCarsSaverGlobalState);
      localStorage.setItem(
        "taggedCarsData",
        JSON.stringify({
          findCars: findCars.get(),
          taggedCarsDisplayerGlobalState: taggedCarsDisplayerGlobalState.get(),
          tagCarsDataMap: taggedCarsSaverGlobalState.get(),
          tagCarsDataFilters: showTaggedCarArray.get(),
        })
      );
    }
  }, [props.notAvailableCars]);

  return (
    <Modal
      open={props.openPopupNotAvailableCars}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {/* <div style={{ float: "right" }} onClick={handleClose}>
          X
        </div> */}
        <PopUpContainer>
          <h4 id="modal-modal-title">Cars Not Found</h4>
          <p id="modal-modal-description">
            Car locations unknown for cars :{" "}
            {props.notAvailableCars.map((item) => item + " ")}
          </p>
          <div className="action-btn">
            <button
              style={{
                float: "right",
                color: "#ffffff",
                backgroundColor: "#947550",
              }}
              onClick={handleClose}
            >
              {t("Ok")}
            </button>
          </div>
        </PopUpContainer>
      </Box>
    </Modal>
  );
};

export default CarNotAvailableModal;
